// @ts-nocheck

export const DefaultPresetsValue = [200, 500, 1000, 2000, -1];
export const BoostedPresetsValue = [500, 1000, 2500, 5000, -1];
export const BigBoostedPresetsValue = [100, 200, 500, 1000, -1];
